import { Partition } from './types';

export const partition = (value: string, start: number, end?: number | undefined): Partition => {
  const source = value.split(' ');

  const target = source.slice(start, end).join(' ');

  let before: string[] = [];
  if (start < 0) {
    before = source.slice(0, source.length + start);
  } else if (start > 0) {
    before = source.slice(0, start);
  }

  let after: string[] = [];
  if (end != null && end < 0) {
    after = source.slice(source.length + end);
  } else if (end != null && end > 0) {
    after = source.slice(end);
  }

  return { before: before.join(' '), target, after: after.join(' ') };
};
